
import React, { useState } from 'react';
import './Pergunta.css';
import Teste from './Teste';
import ImageCasa from './images/premio2.webp';
const Pergunta = ({ pergunta, opcoesResposta, respostaCorreta, onResposta }) => {
  const [respondido, setRespondido] = useState(false);
  const [opcaoEscolhida, setOpcaoEscolhida] = useState(null);
  const [respostaCerta, setResposta] = useState(null);
  const [mostraCasaVermelha, setMostraCasaVermelha] = useState(true);

  const handleResposta = (opcao) => {
    if (!respondido) {
      onResposta(opcao);
      setRespondido(true);
      setOpcaoEscolhida(opcao);
      setResposta(respostaCorreta);

    }
  };

  return (
    <div className="pergunta-container">

      {(() => {
        if (!respondido) {

          return (
            <>
{/*             <div className='container-pergunta-respostas'></div>
 */}              <div className="pergunta-texto">{pergunta}</div>
              {opcoesResposta.map((opcao, index) => {
                return (
                
                  <button
                    key={index}
                    className="opcao-respostabtn"
                    onClick={() => handleResposta(opcao)} 

                   >
                    {opcao}
                  </button>
                );
              })}
            </>
          );

        } else {
          return (
            <div>  <div className='casa-verde'>
            <img src= {ImageCasa}></img>
          </div> 
         
            <div className="opcao-escolhida-mensagem">
                   
                 
                         <div className='reponse-correcte'>
                  
                <div className='Resposta'>
                {respostaCorreta}  <br ></br>
                </div>
              </div> 

            {/*   <div className='mensagem'>
                <p>Reculez d'une case</p>
              </div> */}
            
          {/*     
              {!respostaCorreta ?(
              <div className='casa-vermelha'>

                </div>
              ):(
                <div className='casa-verde'>   </div>
              ) }
        */}

            </div>
            </div>
          
          );   
            
            
            
            /*      return (
            <div className="opcao-escolhida-mensagem">
             <br></br> 
             <div className='reponse-correcte'>
             Réponse correcte : {respostaCorreta}  <br ></br>
             </div>
             
             <div className='reponse-choisie'>

              Votre option choisie : {opcaoEscolhida}
            </div>
            </div>
          ); */
        }

      })()}
    </div>
    
  );
  
};



export default Pergunta;
